import React from "react";
import { formaters, integerCentToFrenchFinanString } from "vincent-utils";
import { BanqueLine2 } from "compta-shared";
import ModeBadge from "../../factures/components/ModeBadge.tsx";
import LockedBadge from "../../utils/components/LockedBadge.tsx";

type BanqueLineCompProps = {
  banqueLine: BanqueLine2;
  selected: boolean;
  onClick: () => void;
  onNotHonorairesClick: (_id: string) => void;
};

const BanqueLineComp = (props: BanqueLineCompProps) => {
  const banqueLine = props.banqueLine;
  const { _id, date, libelle } = banqueLine;
  const montantCent = banqueLine.montantCent;
  const cbBrut =
    banqueLine.type === "remiseCartes" ? banqueLine.remiseCBBrut : null;
  const { onClick, onNotHonorairesClick } = props;
  const handleOnNotHonorairesClick =
    (_id: string) => (e: React.SyntheticEvent) => {
      e.stopPropagation();
      onNotHonorairesClick(_id);
    };
  return (
    <li
      className={"list-group-item" + " " + (props.selected ? "active" : "")}
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      {formaters.formatDateAsDDN(date)} {libelle}{" "}
      {integerCentToFrenchFinanString(montantCent)}{" "}
      {cbBrut ? "brut : " + integerCentToFrenchFinanString(cbBrut) : ""}{" "}
      <ModeBadge mode={banqueLine.type} className="ms-2 align-middle" />{" "}
      {banqueLine.locked === true ? <LockedBadge /> : null}{" "}
      <button
        type="button"
        className="badge bg-secondary border-0"
        disabled={banqueLine.locked === true}
        style={{ cursor: "pointer" }}
        onClick={handleOnNotHonorairesClick(_id)}
      >
        Pas des honoraires ?
      </button>
    </li>
  );
};

export default BanqueLineComp;
